import type { AuthSession, TokenStore } from '@pomodingo/api-client';

const STORAGE_KEY = 'pomodingo.auth.token';

export function createWebTokenStore(): TokenStore {
  return {
    getSession(): AuthSession | null {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      try {
        return JSON.parse(raw) as AuthSession;
      } catch {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
    },

    getAccessToken(): string | null {
      return this.getSession()?.accessToken ?? null;
    },

    setSession(session: AuthSession | null): void {
      if (!session) {
        localStorage.removeItem(STORAGE_KEY);
        return;
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    },
  };
}
